// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.socialIcons_homeHeroSocial__559Xe {
  margin-top: 30px;
  text-align: center;
}

.socialIcons_socialIcons__x86CS {
  list-style: none;
  padding: 0;
  display: flex;
  justify-content: center;
  gap: 15px;
}

.socialIcons_socialIcons__x86CS li {
  display: inline-block;
}

.socialIcons_socialIcons__x86CS a {
  font-size: 1.5rem;
  color: var(--kur-yellow);
  transition: color 0.3s ease;
}

.socialIcons_socialIcons__x86CS a:hover {
  color: #fff;
}
`, "",{"version":3,"sources":["webpack://./src/COMPONENTS/SOCIAL_ICONS/socialIcons.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;AACb","sourcesContent":[".homeHeroSocial {\n  margin-top: 30px;\n  text-align: center;\n}\n\n.socialIcons {\n  list-style: none;\n  padding: 0;\n  display: flex;\n  justify-content: center;\n  gap: 15px;\n}\n\n.socialIcons li {\n  display: inline-block;\n}\n\n.socialIcons a {\n  font-size: 1.5rem;\n  color: var(--kur-yellow);\n  transition: color 0.3s ease;\n}\n\n.socialIcons a:hover {\n  color: #fff;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"homeHeroSocial": `socialIcons_homeHeroSocial__559Xe`,
	"socialIcons": `socialIcons_socialIcons__x86CS`
};
export default ___CSS_LOADER_EXPORT___;
